import { render, staticRenderFns } from "./IconManage.vue?vue&type=template&id=177b7f48&"
import script from "./IconManage.vue?vue&type=script&lang=js&"
export * from "./IconManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports